import React, { forwardRef } from 'react';
import "./Work.css";
import WorkComponent from "../components/WorkComponent";
import WorkComponent2 from "../components/WorkComponent2";
import data from '../data.json';

const Work = forwardRef((props, ref) => {
    return (
        <div id="work" className="work-container">
            <div className="work-title">Projects</div>
            {data.work.map(workItem => {
                if (workItem.id === 2) {
                    return (
                        <WorkComponent2
                            key={workItem.id}
                            id={workItem.id}
                            image={workItem.image}
                            title={workItem.title}
                            description={workItem.shortdescription}
                            tags={workItem.tags}
                            className="work-item" /* Ajoute la classe CSS */
                        />
                    );
                } else {
                    return (
                        <WorkComponent
                            key={workItem.id}
                            id={workItem.id}
                            image={workItem.image}
                            title={workItem.title}
                            description={workItem.shortdescription}
                            tags={workItem.tags}
                            className="work-item" /* Ajoute la classe CSS */
                        />
                    );
                }
            })}
        </div>
    );
});

export default Work;